module.exports = __webpack_public_path__ + "fonts/c75bd0e5ed1a33c28798ea5fc8561971.svg";